import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { Ornament } from './Ornament';
const chooseBy = ['client level', 'body focus', 'class objective', 'mobility goal', 'intensity', 'duration', 'progression stage', 'available teaching time'];
const classesCover = ['Foundations', 'Full-body stretching', 'Lower body', 'Upper body', 'Hips', 'Hamstrings', 'Shoulders', 'Spine mobility', 'Dynamic stretching', 'Active mobility', 'Recovery', 'Posture', 'Full-body mobility', 'Beginner classes', 'Intermediate classes', 'Advanced progressions', 'Mixed-level adaptations'];
export function ClassLibrary() {
  return <section className="bg-background px-4 py-20 sm:py-28" data-id="element-55" data-mp="c0fdn4o4yzze">
      <div className="mx-auto grid max-w-6xl gap-12 lg:grid-cols-[1fr_1.1fr] lg:gap-16" data-id="element-56" data-mp="c31l74b11fhm">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-57" data-mp="2rufpf4dm2mr1">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-primary" data-id="element-58" data-mp="14oee1ih0kfud">
            150 ready-to-teach stretching classes
          </p>
          <h2 className="mt-3 text-3xl font-semibold leading-tight text-foreground sm:text-4xl" data-id="element-59" data-mp="1jn8d73hn6z1w">
            Stop Planning Every Session From an{' '}
            <span className="italic text-primary" data-id="element-60" data-mp="1sm25ihnxx39n">Empty Page</span>
          </h2>
          <Ornament align="left" className="mt-5" data-id="element-61" data-mp="1sjz7pbgjq5ud" />
          <p className="mt-5 text-base leading-7 text-muted-foreground" data-id="element-62" data-mp="1nm7bw6cs5zkw">
            This is the practical heart of Stretching Instructor Ready. Across
            the complete 6-in-1 system, you receive:
          </p>
          <div className="mt-6 flex items-center gap-5 border-y border-accent/30 py-6" data-id="element-63" data-mp="1xdk44z2hqrrg">
            <span className="font-display text-6xl font-semibold leading-none text-primary" data-id="element-64" data-mp="2bdmiibblb31y">
              150
            </span>
            <span className="text-sm font-semibold uppercase leading-6 tracking-[0.08em] text-foreground" data-id="element-65" data-mp="279564x7k7s17">
              Structured stretching classes
              <span className="block font-medium normal-case tracking-normal text-muted-foreground" data-id="element-66" data-mp="2jekiolnbvgd9">
                ready to use.
              </span>
            </span>
          </div>
          <p className="mt-6 text-sm font-semibold text-foreground" data-id="element-67" data-mp="2t3u6vqf1wew3">
            Choose according to:
          </p>
          <ul className="mt-2 grid gap-x-4 gap-y-1.5 sm:grid-cols-2" data-id="element-68" data-mp="2x3w33k20og3z">
            {chooseBy.map(item => <li key={item} className="flex gap-2.5 text-sm leading-6 text-muted-foreground" data-id="element-69" data-mp="322pe95ttzv0z">
                <CheckIcon size={16} className="mt-1 shrink-0 text-success" aria-hidden="true" data-id="element-70" data-mp="3c26jxn9328wy" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="self-start rounded-2xl border border-accent/30 bg-surface p-6 shadow-card sm:p-9" data-id="element-71" data-mp="1hoyobtda9ta9">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-primary" data-id="element-72" data-mp="3m3qyqjff4l83">
            Classes cover:
          </p>
          <ul className="mt-5 flex flex-wrap gap-2" data-id="element-73" data-mp="hseznx3z5ayn">
            {classesCover.map(item => <li key={item} className="rounded-full border border-primary/20 bg-surface-subtle px-3 py-1.5 text-xs font-medium text-foreground" data-id="element-74" data-mp="dps8zzj1hw31">
                {item}
              </li>)}
          </ul>
          <div className="mt-8 border-t border-accent/25 pt-6" data-id="element-75" data-mp="3ui3h1tfn6ki">
            <p className="text-sm font-medium text-muted-foreground" data-id="element-76" data-mp="2ti8zfu804hm1">
              Instead of asking:
            </p>
            <p className="mt-1 font-display text-xl font-medium italic leading-8 text-foreground" data-id="element-77" data-mp="2oh1s1w9rtkfw">
              “What am I teaching tomorrow?”
            </p>
            <p className="mt-3 text-base leading-7 text-foreground" data-id="element-78" data-mp="l0n62j29pbei">
              Open the system and already have a{' '}
              <span className="font-semibold text-primary" data-id="element-79" data-mp="7ajmjzurvvsr">
                structured starting point.
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}